import { render, staticRenderFns } from "./cancellationAndReturn.vue?vue&type=template&id=016d7e32&"
import script from "./cancellationAndReturn.vue?vue&type=script&lang=js&"
export * from "./cancellationAndReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports